import {Link} from "react-router";
import {useContext} from "react";
import {Loading} from "../components/loading.tsx";

import GeneralContext from "../contexts/Gneral.tsx";

export function Home () {
    const  data  = useContext(GeneralContext);
    return (<div className={'welcome-screen'}>
        { data ? <div>
            <h1>{data?.contents.welcomeScreenHeading1} <br />{data?.contents.welcomeScreenHeading2}</h1>
            <p>{data?.contents.WelcomeScreenContent}</p>
            <Link to="/intro" className={'btn'}>כניסה</Link>
        </div>  : <Loading />}
    </div>);
}